document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.custom-carousel .carousel-wrapper');
  const slides = document.querySelectorAll('.carousel-slide');
  const prev = document.querySelector('.carousel-prev');
  const next = document.querySelector('.carousel-next');

  let index = 0;

  function scrollToSlide(i) {
    if (i < 0) index = 0;
    else if (i >= slides.length) index = slides.length - 1;
    else index = i;

    const slide = slides[index];
    // Scroll wrapper so this slide is at the start
    wrapper.scrollTo({
      left: slide.offsetLeft - wrapper.offsetLeft,
      behavior: 'smooth'
    });
  }

  /*prev.addEventListener('click', function(e) {
    e.preventDefault(); // Prevent page scrolling
    scrollToSlide(index - 1);
  });

  next.addEventListener('click', function(e) {
    e.preventDefault(); // Prevent page scrolling
    scrollToSlide(index + 1);
  });*/

  // Optional: Auto-scroll every 5s
  //setInterval(() => scrollToSlide(index + 1), 5000);
});